


// We're gonna do very strict type checking for all of the local storage shit.
// Don't want to set or give back anything invalid
export const getLocalVisitId = () => {
    const userId = localStorage.getItem('user_id')
    if (!userId || (typeof(userId) === 'string' && userId === "null")) {
        return null
    } else {
        const localVisitId = localStorage.getItem(`${userId}_visit_id`)
        if (!localVisitId ||(typeof(localVisitId) === 'string' && localVisitId === "null")) {
            return null
        } else {
            return localVisitId
        }
    }
}

export const setLocalVisitId = (visitId) => {
    try {
        const userId = localStorage.getItem('user_id')
        if (!userId || (typeof(userId) === 'string' && userId === "null")) {
            throw new Error("Invalid user_id: user_id not defined")
        } else {
            if (visitId && typeof(visitId) === 'string') {
                localStorage.setItem(`${userId}_visit_id`, visitId);
            } else {
                throw new Error("Invalid visitId");
            }
        }
    } catch(error) {
        throw new Error(error)
    }
}

export const clearLocalVisitId = () => {
    try {
        const userId = localStorage.getItem('user_id')
        if (!userId || (typeof(userId) === 'string' && userId === "null")) {
            throw new Error("Invalid user_id: user_id not defined")
        } else {
            localStorage.removeItem(`${userId}_visit_id`);
        }
    } catch(error) {
        throw new Error(error);
    }
}


